import { gql } from '@apollo/client';

export const GET_DEAL_OPPORTUNITY_IC_FUND_RESULT = gql`
  query DealOpportunityIcFundResult($id: ID!) {
    node(id: $id) {
      ... on OpportunityNode {
        icFundResult
      }
    }
  }
`;

export interface GetDealOpportunityIcFundResult {
  node: {
    __typename: 'OpportunityNode';
    icFundResult: IcFundResult | null;
  };
}

export type IcFundResult = Record<string, IcFundResultItem>;

export interface IcFundResultItem {
  abstain_count: number;
  approve_count: number;
  committee_name: string;
  completed_votes: number;
  fund_id: number;
  fund_name: string;
  pending_count: number;
  reject_count: number;
  status: string;
  threshold: number;
  total_votes: number;
}

/** Stages that require all IC fund statuses to be "passed" before they can be used. */
export const DUE_DILIGENCE_STAGES_REQUIRING_ALL_FUNDS_PASSED = [
  'Legal, Tax, ESG',
  'Closing',
  'Post-Close'
] as const;

/**
 * Returns true if icFundResult is present and every fund has status "passed" (case-insensitive).
 * Returns false if icFundResult is null, empty, or any fund is not passed.
 */
export function areAllFundStatusesPassed(
  icFundResult: IcFundResult | null | undefined
): boolean {
  if (!icFundResult || typeof icFundResult !== 'object') {
    return false;
  }
  const items = Object.values(icFundResult);
  if (items.length === 0) {
    return false;
  }
  return items.every(item => (item?.status ?? '').toUpperCase() === 'PASSED');
}
